import { num } from "@/lib/format";

export function Dot({ color, pulse, className = "" }) {
  return (
    <span
      className={`inline-block w-2 h-2 rounded-full ${pulse ? "animate-pulse" : ""} ${className}`}
      style={{ backgroundColor: color, boxShadow: `0 0 8px ${color}` }}
    />
  );
}

export function StatCard({ label, value, unit, color, testid, icon: Icon }) {
  return (
    <div data-testid={testid} className="bg-[#141414] border border-white/10 rounded-sm p-4 relative overflow-hidden">
      <div className="flex items-center justify-between">
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#A3A3A3]">{label}</span>
        {Icon && <Icon size={16} className="text-[#525252]" />}
      </div>
      <div className="mt-2 flex items-baseline gap-1">
        <span className="font-mono text-3xl font-bold tracking-tight" style={{ color: color || "#fff" }}>{value}</span>
        {unit && <span className="font-mono text-xs text-[#A3A3A3]">{unit}</span>}
      </div>
    </div>
  );
}

export function Gauge({ value, label, color }) {
  const pct = Math.max(0, Math.min(100, value ?? 0));
  return (
    <div className="space-y-1">
      <div className="flex justify-between items-baseline">
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#A3A3A3]">{label}</span>
        <span className="font-mono text-sm font-bold" style={{ color }}>{num(value, 0)}%</span>
      </div>
      <div className="h-1.5 bg-white/5 rounded-sm overflow-hidden">
        <div className="h-full transition-all duration-500" style={{ width: `${pct}%`, backgroundColor: color }} />
      </div>
    </div>
  );
}

export function Field({ label, value, unit, color, testid }) {
  return (
    <div data-testid={testid} className="bg-[#0A0A0A] border border-white/10 rounded-sm px-3 py-2">
      <div className="font-mono text-[9px] tracking-[0.2em] uppercase text-[#525252]">{label}</div>
      <div className="font-mono text-base font-bold mt-0.5" style={{ color: color || "#fff" }}>
        {value}{unit && <span className="text-[10px] text-[#A3A3A3] ml-1">{unit}</span>}
      </div>
    </div>
  );
}
